import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getRecents } from '../../api/recent';

import { REQUEST } from '../../constants/request';

export const fetchRecents = createAsyncThunk(
  'recent/fetchRecents',
  async (arg, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getRecents({
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const RecentSlice = createSlice({
  name: 'recent',
  initialState: {
    recent: {
      threadChannels: [],
      tags: [],
      mentions: [],
      userId: '',
      threads: [],
      rebuzzChannels: [],
      searches: [],
    },
  },
  loading: REQUEST.idle,
  requestId: undefined,
  error: null,
  reducers: {},
  extraReducers: {
    [fetchRecents.pending]: (state, { meta }) => {
      const { requestId } = meta;

      state.error = undefined;
      state.loading = REQUEST.pending;
      state.requestId = requestId;
    },
    [fetchRecents.fulfilled]: (state, { meta, payload }) => {
      if (
        state.loading === REQUEST.pending &&
        state.requestId === meta.requestId
      ) {
        state.recent = { ...state.recent, ...payload };
      }

      state.loading = REQUEST.idle;
      state.requestId = undefined;
    },
    [fetchRecents.rejected]: (state, { payload }) => {
      state.loading = REQUEST.idle;
      state.requestId = undefined;
      state.error = payload;
    },
  },
});

export default RecentSlice.reducer;

export const selectorGetRecentTags = state => state.recent.recent;
export const selectorGetRecentLoadingState = state => state.recent.loading;
